import { render, staticRenderFns } from "./IntegrationDiffTable.vue?vue&type=template&id=38bc11c6&"
import script from "./IntegrationDiffTable.vue?vue&type=script&lang=js&"
export * from "./IntegrationDiffTable.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationDiffTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports